import { createReducer } from 'redux-create-reducer'
import type {
  ClientLibraryDiscoveryPanelItem,
  ClientLibraryId,
} from 'types/client-library'
import {
  CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE,
  CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_FAIL,
  CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD,
  CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_FAIL,
  CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT,
  CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT_FAIL,
  CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT_SUCCESS,
  CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_SUCCESS,
  CLIENT_LIBRARY_DISCOVERY_PANEL_REQUEST_ACCESS,
  CLIENT_LIBRARY_DISCOVERY_PANEL_REQUEST_ACCESS_FAIL,
} from '@disco/constants/ActionTypes'
export type State = {
  error: Error | null | undefined
  loading: boolean
  loaded: boolean
  next: string | null | undefined
  items: Record<ClientLibraryId, ClientLibraryDiscoveryPanelItem>
  list: ClientLibraryId[]
  count: number
}
const initialState: State = {
  error: null,
  loading: false,
  loaded: false,
  next: null,
  items: {},
  list: [],
  count: 0,
}
export const discoveryPanelReducer = createReducer<State, any>(initialState, {
  [CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD](state: State) {
    return { ...state, error: null, loading: true, next: null, list: [] }
  },

  [CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_SUCCESS](
    state: State,
    { response }: Record<string, any>,
  ) {
    const items = {}
    response.results.forEach(library => {
      items[library.id] = { ...library }
    })
    return {
      ...state,
      error: null,
      loaded: true,
      loading: false,
      next: response.next,
      items,
      list: response.results.map(library => library.id),
      count: response.count,
    }
  },

  [CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_FAIL](
    state: State,
    { error }: Record<string, any>,
  ) {
    return { ...state, error, loading: false }
  },

  [CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT](state: State) {
    return { ...state, error: null, loading: true }
  },

  [CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT_SUCCESS](
    state: State,
    { response }: Record<string, any>,
  ) {
    const items = { ...state.items }
    response.results.forEach(item => {
      items[item.id] = { ...items[item.id], ...item }
    })
    return {
      ...state,
      error: null,
      loaded: true,
      loading: false,
      next: response.next,
      items,
      list: [...state.list, ...response.results.map(library => library.id)],
    }
  },

  [CLIENT_LIBRARY_DISCOVERY_PANEL_LOAD_NEXT_FAIL](
    state: State,
    { error }: Record<string, any>,
  ) {
    return { ...state, error, loading: false }
  },

  [CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE](state, { libraryId, isFavorite }) {
    if (!state.items[libraryId]) return state
    return {
      ...state,
      items: {
        ...state.items,
        [libraryId]: { ...state.items[libraryId], is_favorite: isFavorite },
      },
    }
  },

  [CLIENT_LIBRARY_DISCOVERY_PANEL_FAVORITE_FAIL](
    state,
    { libraryId, isFavorite },
  ) {
    if (!state.items[libraryId]) return state
    return {
      ...state,
      items: {
        ...state.items,
        [libraryId]: { ...state.items[libraryId], is_favorite: !isFavorite },
      },
    }
  },

  [CLIENT_LIBRARY_DISCOVERY_PANEL_REQUEST_ACCESS](state, { libraryId }) {
    if (!state.items[libraryId]) return state
    return {
      ...state,
      items: {
        ...state.items,
        [libraryId]: { ...state.items[libraryId], status: 'pending' as const },
      },
    }
  },

  [CLIENT_LIBRARY_DISCOVERY_PANEL_REQUEST_ACCESS_FAIL](
    state,
    { libraryId, status },
  ) {
    if (!state.items[libraryId]) return state
    return {
      ...state,
      items: {
        ...state.items,
        [libraryId]: { ...state.items[libraryId], status },
      },
    }
  },
})
